export default __webpack_public_path__ + "static/media/15.37efdab4.jpeg";